import PropTypes from 'prop-types';
import React from 'react';
import Loader from 'src/components/loader';

const ActionUndoConfirmation = ({ isUndoLoading, handleConfirmUndoAction, closeActionPanel }) => (
  <div>
    <div className='mb30'>Are you sure you want to undo this action?</div>

    <button
      type='button'
      className='btn btn-lg btn-primary action-btn btn-block mt60'
      disabled={isUndoLoading}
      onClick={handleConfirmUndoAction}
    >
      <p className='d-flex align-items-center justify-content-center mb0'>
        Yes
        {isUndoLoading && <Loader inline className='spacer-left' showText={false} />}
      </p>
    </button>

    <button type='button' className='btn btn-lg btn-block' onClick={closeActionPanel}>
      No
    </button>
  </div>
);

ActionUndoConfirmation.propTypes = {
  isUndoLoading: PropTypes.bool.isRequired,
  handleConfirmUndoAction: PropTypes.func.isRequired,
  closeActionPanel: PropTypes.func.isRequired,
};

export default ActionUndoConfirmation;
